import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/shared/service/auth.service';

@Component({
  selector: 'app-super-admin',
  templateUrl: './super-admin.component.html',
  styleUrls: ['./super-admin.component.scss']
})
export class SuperAdminComponent implements OnInit {

  constructor(public AuthService: AuthService) { }

  ngOnInit() {

    console.log("isAdmin", this.AuthService.isSuperAdmin );
  }

}
